module.exports = __webpack_public_path__ + "static/media/au2.ea5c8740.jpg";